import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { ShieldCheck } from "lucide-react";

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  return Number.isNaN(d.getTime())
    ? value
    : new Intl.DateTimeFormat("id-ID", { dateStyle: "long" }).format(d);
}

export default function InterviewSignature({ score }) {
  if (!score?.id) return null;
  const date = formatDate(score.created_at);
  const verifyValue = [
    "VERIFIKASI PENILAIAN WAWANCARA MDJ",
    `ID: ${score.id}`,
    `Pewawancara: ${score.interviewer_name || "-"}`,
    `Tanggal: ${date}`,
  ].join("\n");

  return (
    <div className="mt-5 rounded-xl border border-[#D3EFDF] bg-[#F0FBF5] p-5" data-testid="interview-signature">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-2 text-[#0B6B3A]">
          <ShieldCheck className="h-4 w-4" />
          <span className="text-xs font-bold uppercase tracking-wide">Tanda Tangan Digital</span>
        </div>
        <div className="text-right text-xs text-[#1F2937]">
          <p>Jakarta, {date}</p>
          <p className="mt-0.5 font-semibold">Pewawancara,</p>
        </div>
      </div>
      <div className="mt-3 flex flex-col items-center">
        <div className="rounded-lg border border-[#D3EFDF] bg-white p-2">
          <QRCodeCanvas value={verifyValue} size={96} level="M" includeMargin data-testid="interview-signature-qr" />
        </div>
        <p className="mt-2 text-sm font-bold text-[#1F2937]">( {score.interviewer_name || "-"} )</p>
        <p className="mt-1 text-center text-[10px] text-[#6B7280]">
          Tanda tangan digital — pindai QR untuk memverifikasi keaslian hasil penilaian ini.
        </p>
      </div>
    </div>
  );
}
